import { render, staticRenderFns } from "./SeguroMoto.vue?vue&type=template&id=a86ab068&scoped=true&"
import script from "./SeguroMoto.vue?vue&type=script&lang=js&"
export * from "./SeguroMoto.vue?vue&type=script&lang=js&"
import style0 from "./SeguroMoto.vue?vue&type=style&index=0&id=a86ab068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86ab068",
  null
  
)

export default component.exports